export default {
  "root": "_root_d37ae_1",
  "--type-literal": "_--type-literal_d37ae_1",
  "--type-unit": "_--type-unit_d37ae_1",
  "--type-literal--m": "_--type-literal--m_d37ae_1",
  "--type-unit--m": "_--type-unit--m_d37ae_1",
  "--type-literal--l": "_--type-literal--l_d37ae_1",
  "--type-unit--l": "_--type-unit--l_d37ae_1",
  "--type-literal--xl": "_--type-literal--xl_d37ae_1",
  "--type-unit--xl": "_--type-unit--xl_d37ae_1"
};import "ni:sha-256;GybEUaqFBGASAZgjsXBLzqzQHSvxs2DqZgSAOUzlZ_I";